import { debounce } from '@mui/material/utils';
import { useCallback, useEffect, useRef } from 'react';

// Solution found here: https://stackoverflow.com/a/62017005
// mixed with MUI example here: https://mui.com/material-ui/react-autocomplete/#search-as-you-type
export default function useThrottle(
  // biome-ignore lint/suspicious/noExplicitAny: theoretically can be any callback
  cb: (...args: any[]) => void,
  ms = 500,
): typeof cb & { clear: () => void } {
  const cbRef = useRef(cb);
  // use mutable ref to make useCallback/throttle not depend on `cb` dep
  useEffect(() => {
    cbRef.current = cb;
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: we do need this as a dependency
  return useCallback(debounce<typeof cb>(cbRef.current, ms), [ms]);
}
